import { UserAddress } from "@providers/profile/ProfileProvider.model";
import { BillingState } from "../subscription/Subscription.model";

export const addressInitialValues = {
  line1: "",
  line2: "",
  city: "",
  state: "",
  postal_code: "",
};

export interface AddressValues {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postal_code: string;
}

export const addressValues = (address: UserAddress, initialValues?: AddressValues) => {
  const formattedValues = {};

  if (address) {
    Object.keys(addressInitialValues).forEach((key) => {
      formattedValues[key] = address[key] || "";
    });
  }

  return (
    initialValues || {
      ...addressInitialValues,
      ...formattedValues,
    }
  );
};

export interface StateSchema {
  _key: string;
  abbr: string;
  name: string;
}

export interface AddressComponentProps {
  address?: UserAddress;
  dispatchBilling: React.Dispatch<React.SetStateAction<BillingState>>;
  states: Array<StateSchema>;
}

export interface FormStatusState {
  loading: boolean;
  editing: boolean;
  error: string | null;
}

export const initialFormStatusState = {
  loading: false,
  editing: false,
  error: null,
};
